<template>
  <div>
    <div class="container zh-box" v-if="langId == 'zh'">
        <div class="title">活动11号准时开始</div>
        <div class="content">
            <div class="item-title">一、活动时间：</div>
            <div class="item-content">2025年11月11日0时至2025年11月16日23:59时，共计六天。</div>
            <div class="item-title">二、参与方式：</div>
            <div class="item-content">进入美滋来外卖平台，点击首页弹窗或首页中的活动区域，即可进入活动游戏页面。在游戏中，从屏幕上方会不断飘下雪花，雪花分为白色、金色、黑色雪花等三种。点击白色雪花时，会随机获取游戏积分，点击金色雪花可获得30积分奖励或无门槛优惠券，如果不小心点击到黑色雪花则会按游戏规则中的比例扣除当场游戏积分并且结束游戏。随着游戏中获取的积分不断增加，雪花的下落速度也会逐渐加快，活动累计积分越高，游戏的难度也会越大。</div>
            <div class="item-title">三、活动排行榜与奖品</div>
            <div class="item-content">本次活动中根据参与者在游戏中获得的累计积分，特设立游戏参与者排行榜，排行榜前三十位的玩家将获得额外奖品。活动结束前，每位参与者都有机会争取这些奖品。具体奖品如下：</div>
            <div class="item-content">1.一等奖：1名</div>
            <div class="item-content">奖品：iPhone 17 Pro Max 256GB手机；</div>
            <div class="item-content">2.二、三等奖：各1名，共2名</div>
            <div class="item-content">奖品：iPhone 17 256GB手机；</div>
            <div class="item-content">3.四到至十等奖：各1名，共7名</div>
            <div class="item-content">华为 nova 14 256GB 手机；</div>
            <div class="item-content">4.十一到三十等奖：各1名，共20名</div>
            <div class="item-content">奖品：千足金戒指。</div>
            <div class="item-title">四、兑奖时间</div>
            <div class="item-content">活动结束后，总排行榜确认产生前三十名中奖者后的一周为兑奖期。获奖者可在”美滋来（Mulazim）平台”“我的”页面“美滋来下雪了”活动选项里确认获奖情况，并下方的“兑换奖品”里面正确填写联系方式和居住地址。</div>
            <div class="item-title">五、注意事项</div>
            <div class="item-content">1.公平公正：本次活动严禁任何形式的技术篡改中奖结果或利用不正当手段破坏游戏公平性。一经发现，平台有权取消该用户的中奖资格，追回已发放的奖品及优惠券，并保留进一步追究其法律责任的权利。</div>
            <div class="item-content">2.活动解释权：本次活动最终解释权归美滋来平台所有。平台有权根据活动实际情况对规则进行调整，并提前在平台发布相关公告。</div>
        </div>
    </div>
    <div class="container ug-box" v-if="langId == 'ug'">
      <div class="title">پائالىيەت باشلىنىشقا 1 كۈن قالدى</div>
      <div class="content">
        <div class="item-title">1. پائالىيەت ۋاقتى</div>
        <div class="item-content">
          2025 – يىلى 11 – ئاينىڭ 11 – كۈنى سائەت 0دىن 2025 – يىلى 11 – ئاينىڭ
          16 – كۈنى سائەت 23:59 غىچە جەمئىي 6 كۈن.
        </div>
        <div class="item-title">2. قاتنىشىش ئۇسۇلى</div>
        <div class="item-content">
          مۇلازىم سۇپىسىغا كىرىپ، ئېكراندىكى پائالىيەت سەكرەتمە كۆزنەكنى ياكى
          باش بەتتىكى پائالىيەت رايونىنى بېسىپ پائالىيەتكە قاتنىشىسىز.
        </div>
        <div class="item-content">
          پائالىيەتتە ئېكران ئۈستىدىن توختىماستىن قار ئۇچقۇنلىرى چۈشىدۇ. قار ئاق
          رەڭلىك قار، ئالتۇن رەڭلىك قار ۋە قارا رەڭلىك قاردىن ئىبارەت ئۈچ خىلغا
          بۆلۈنىدۇ. ئاق رەڭلىك قارنى تۇتسىڭىز ئويۇن جۇغلانما نومۇرىغا
          ئېرىشەلەيسىز، ئالتۇن رەڭلىك قارنى تۇتسىڭىز 30 جۇغلانما نومۇرغا ياكى
          شەرتسىز ئىشلىتىدىغان ئېتىبار بېلەتكە ئېرىشەلەيسىز، قارا رەڭلىك قارنى
          تۇتۇۋالسىڭىز شۇ مەيداندىكى جۇغلانما نومۇرىڭىزدىن ئويۇن قائىدىسىدىكى
          بەلگىلەنگەن نىسبەت بويىچە نومۇر تارتىلىدۇ ۋە ئويۇن ئاخىرلىشىدۇ.
          ئومۇمىي جۇغلانما نومۇرىڭىز كۆپەيگەنچە ئويۇننىڭ باشلىنىش قىيىنلىق
          دەرىجىسى يۇقىرىلاپ بارىدۇ.
        </div>
        <div class="item-title">3. پائالىيەت تەرتىپ تىزمىسى ۋە مۇكاپاتلار</div>
        <div class="item-content">
          پائالىيەت مەزگىلىدە، ھەر بىر مەيدان ئويۇندا ئېرىشكەن جۇغلانما
          نومۇرىڭىز جەملىنىپ، پائالىيەت ئومۇمىي جۇغلانما نومۇرى بولۇپ
          ھېسابلىنىدۇ. ئويۇنغا قاتناشقۇچىلارنىڭ ئېرىشكەن ئومۇمىي جۇغلانما
          نومۇرىنىڭ ئاز - كۆپلۈكى بويىچە دەرىجە تەرتىپى تۇرغۇزۇلۇپ، پائالىيەت
          ئاخىرلاشقاندىكى ئەڭ ئاخىرقى ئومۇمىي تەرتىپتىكى ئالدىنقى 30 نەپەر
          قاتناشقۇچىغا ئالاھىدە مۇكاپات تەسىس قىلىندى. پائالىيەت ئاخىرلىشىشتىن
          بۇرۇن، ھەر بىر قاتناشقۇچىنىڭ باراۋەر ئاساستا دەرىجە تەرتىپىدىكى
          ئالدىنقى ئورۇنلارغا جەڭ ئېلان قىلىش پۇرسىتى بار.
        </div>
        <div class="item-content">تەسىس قىلىنغان مۇكاپاتلار تۆۋەندىكىچە:</div>
        <div class="item-content">بىرىنچى دەرىجىلىك مۇكاپات 1 دانە</div>
        <div class="item-content">
          مۇكاپات بۇيۇمى: iPhone 17 Pro Max 256G نۇسخىسى؛
        </div>
        <div class="item-content">
          ئىككىنچى ۋە ئۈچىنچى دەرىجىلىك مۇكاپات ھەربىرى 1 دانىدىن، جەمئىي 2 دانە
        </div>
        <div class="item-content">مۇكاپات بۇيۇمى: iPhone 17 256G نۇسخىسى ؛</div>
        <div class="item-content">
          تۆتىنچى دەرىجىدىن ئونىنچى دەرىجىگىچە مۇكاپات جەمئىي 7 دانە
        </div>
        <div class="item-content"> مۇكاپات بۇيۇمى: 14华为 Nova يانفونى ؛</div>
        <div class="item-content">
          ئون بىرىنچىدىن ئوتتۇزىنچى دەرىجىگىچە جەمئىي مۇكاپات 20 دانە
        </div>
        <div class="item-content"> مۇكاپات بۇيۇمى: ئالتۇن ئۈزۈك.</div>
        <div class="item-title">4. مۇكاپات نەقلەشتۈرۈش</div>
        <div class="item-content">
          مۇكاپات نەقلەشتۈرۈش ۋاقتى پائالىيەت ئاخىرلىشىپ، ئومۇمىي دەرىجە تەرتىپى
          مۇقىملاشقاندىن باشلاپ بىر ھەپتە ئىچىدە ئېلىپ بېرىلىدۇ، مۇكاپاتقا
          ئېرىشىكۈچىلەر مۇلازىم سۇپىسىدىكى «مېنىڭ» بېتىدىن، «مۇلازىمدا قار
          ياغدى» دېگەن تىزىملىكنى چېكىپ كىرىپ، ئېرىشكەن مۇكاپاتىنى
          مۇقىملاشتۇرۇپ، ئاستىدىكى مۇكاپات نەقلەشتۈرۈش دېگەن جايغا چوقۇم توغرا
          بولغان ئالاقە نومۇرى ۋە ئادرېسىىنى قالدۇرۇپ قويۇشى كېرەك.
        </div>
        <div class="item-title">5. ئەسكەرتىش</div>
        <div class="item-content">
          1) مەزكۇر پائالىيەتتە ھەرقانداق شەكىلدە تېخنىكىلىق ياكى باشقا
          شەكىلدىكى ناتوغرا ئۇسۇللارنى قوللىنىش چەكلىنىدۇ. ئەگەر بايقىلىپ قالسا،
          سۇپىمىز مەزكۇر قاتناشقۇچىنىڭ مۇكاپاتقا ئېرىشىش سالاھىيىتىنى بىكار
          قىلىپ، تارقىتىلغان ئېتىبار بېلەتنى قايتۇرۇۋېلىش بىلەن بىرگە قانۇن
          ئورۇنلىرى ئارقىلىق قانۇنىي جاۋابكارلىقىنى سۈرۈشتە قىلىدۇ.
        </div>
        <div class="item-content">
          2) مەزكۇر پائالىيەتنىڭ چۈشەندۈرۈش ھوقوقى مۇلازىم سۇپىسىغا تەۋە.
          سۇپىمىز پائالىيەت ئەھۋالىغا قاراپ، پائالىيەت قائىدىسىنى تەڭشەشكە
          ھوقوقلۇق. پائالىيەت قائىدىسىنى تەڭشەشتىن بۇرۇن سۇپىمىزدا ئالدىن
          ئۇقتۇرۇش قىلىنىدۇ.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "snow_rule",
  data() {
    return {
      langId: this.$route.query.langId,
    };
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
  font-size: 16px;
}
.ug-box {
  direction: rtl;
}
.zh-box {
  direction: ltr;
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 14px;
}
.content {
  line-height: 1.4em;
}
.item-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 4px;
  text-indent: 2em;
}
.item-content {
  text-indent: 2em;
  margin-bottom: 4px;
}
</style>
